// @flow

import ReduceStore from 'PMT/flux/ReduceStore';

// -- constant
import Events from 'constants/Events';
import ActionTypes from 'constants/ActionTypes';

// -- entity
import ApiError from 'PMT/entities/ApiError';
import PaymentsList from 'PMT/entities/PaymentsList';

class PaymentStore extends ReduceStore {

  getInitialState() {
    return {
      paymentsList: null,
      apiError: null,
    }
  }

  getStateObjectsMap() {
    return {
      apiError: new ApiError(),
      paymentsList: new PaymentsList(),
    }
  }

  getApiError(): ApiError {
    return this._state.apiError;
  }

  getPaymentsList(): PaymentsList {
    return this._state.paymentsList;
  }

  reduce(state, action, nextState) {
    switch(action.type) {

      case ActionTypes.LOGOUT:
      case ActionTypes.GET_RESTAURANT_FOR_GROUP_REQUEST:
        return this.getInitialState();

      // -- user payments

      case ActionTypes.GET_USER_PAYMENTS_RESPONSE_SUCCESS:
        nextState.paymentsList = action.paymentsList;
        nextState.apiError = null;
        return nextState;

      case ActionTypes.GET_USER_PAYMENTS_RESPONSE_FAILURE:
        nextState.apiError = action.apiError;
        return nextState;

      default:
        return nextState;
    }
  }

}

export default new PaymentStore();
